import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/PageHero";
import { GoldButton } from "@/components/Buttons";

const VIDEOS = [
  { src: "https://assets.cdn.filesafe.space/yJ0rco4weMdffioqf6zQ/media/66ed1caa36119f369bc5bf01.mp4", label: "Client story" },
  { src: "https://assets.cdn.filesafe.space/yJ0rco4weMdffioqf6zQ/media/69cd361bc85939a73a3222b5.mp4", label: "Client story" },
];

export const VideoTestimonials = ({ showHeading = true, showCta = true }) => (
  <div>
    {showHeading && (
      <>
        <Reveal><Eyebrow>Straight from the field</Eyebrow></Reveal>
        <Reveal delay={80}>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl text-cream leading-tight max-w-3xl">
            Results from business owners <span className="text-gold">who took the call.</span>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="mt-5 text-parch max-w-2xl">These aren't screenshots of dashboards. These are owners who were in the exact place you are right now.</p>
        </Reveal>
      </>
    )}

    <Reveal delay={150}>
      <div className="mt-12 grid grid-cols-2 gap-4 sm:gap-6 max-w-xl mx-auto">
        {VIDEOS.map((v, i) => (
          <div
            key={i}
            data-testid={`testimonial-video-${i}`}
            className="relative aspect-[9/16] bg-ink-900 border border-gold/25 overflow-hidden group hover:border-gold/60 hover:shadow-[0_0_36px_rgba(201,146,58,0.2)] transition-all duration-500"
          >
            <span className="absolute top-0 inset-x-0 h-[3px] bg-gold z-10" />
            <video
              src={v.src}
              controls
              playsInline
              preload="metadata"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
    </Reveal>

    <Reveal delay={120}>
      <figure className="mt-14 max-w-2xl mx-auto text-center">
        <div className="font-display text-6xl text-gold/40 leading-none">&ldquo;</div>
        <blockquote className="font-display italic text-xl sm:text-2xl lg:text-[1.7rem] text-cream leading-snug -mt-3">
          Within 60 days of running ads, customers were calling who already knew the work, had seen the videos, and just wanted to know when we could start.
        </blockquote>
        <figcaption className="label mt-5 text-[11px] text-parch">Kitchen Remodeler, Central Florida</figcaption>
      </figure>
    </Reveal>

    {showCta && (
      <Reveal delay={120}>
        <div className="mt-12 text-center">
          <GoldButton href="https://go.prolificmaven.com/widget/bookings/prolificmavendiscovery" testid="testimonials-cta">
            Get results like this in your market <span aria-hidden>→</span>
          </GoldButton>
        </div>
      </Reveal>
    )}
  </div>
);

export default VideoTestimonials;
